<template>
    <div class="flex flex-col h-auto min-h-screen max-h-screen w-full bg-green-90">
        <div class="w-full px-5 md:px-10 lg:px-32 xl:px-64 pt-4 pb-3 text-grey-700 text-3xl sm:text-4xl">
			<a @click="goBack" @keypress.enter="goBack" tabindex="0" class="cursor-pointer">
				<svg class="inline-block align-middle mr-1 -mt-1" width="30" height="30" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19.375 23.25L11.625 15.5L19.375 7.75" class="stroke-current" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</a>

			Switch city
		</div>
		<div class="px-5 md:px-10 lg:px-32 xl:px-64 pt-1 pb-32 text-green-1000 text-xl overflow-x-hidden overflow-y-auto">
			<div v-if="error" class="mb-4 py-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-red-600 text-white text-xl font-body">
				{{ error }}
			</div>
			
            <div v-if="online_config.cities.length > 0">
                <a v-for="city in online_config.cities" @click="selectCity(city)" @keypress.enter="selectCity(city)" tabindex="0" class="block mt-3 px-3 pt-3 pb-2 border-8 border-solid border-green-600 cursor-pointer" :class="{'bg-green-300 border-grey-600': selected_city == city, 'bg-green-90': selected_city != city}">
                    <h6 class="text-green-900 font-body font-bold capitalize" :class="{'text-grey-600': selected_city == city}" style="font-size: 1.4rem;">{{ city.replace('_', '') }}</h6>
                </a>
            </div>
		</div>

		<a @click="save" @keypress.enter="save" tabindex="0" class="fixed bottom-0 left-0 w-full font-sans border-none bg-red-600 text-red-80 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
			UPDATE
		</a>
    </div>
</template>

<script>
import Storages from 'js-storage';
import axios from 'axios';

export default {
    name: 'SettingsCity',
    path: '/settings/city',
	data() {
		return {
			error: '',
			selected_city: '',
			storage: null,
			key: '',
			user: {
				id: 0,
				username: '',
				email: '',
				premium: false
			},
			online_config: {}
		}
	},
    created() {
        this.storage = Storages.localStorage;

		this.online_config = this.storage.get('online_config');
        if (this.online_config.cities == false) {
            this.$router.replace("/settings");
        }

		this.getCurrentUser();
    },
    methods: {
		goBack() {
			if (window.history.length == 1) {
				this.$router.replace("/settings");
				return;
			}
			
			this.$router.go(-1);
		},
		submitCity(city) {
			var that = this;
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/update/city?city=' + city + '&key=' + that.key)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.user.city = that.selected_city;
                    that.storage.set('authed_user', that.user);
                    that.$router.go(-1);
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
                    that.error = data.response;
				} else {
					that.error = "An unknown error has occured.";
				}
			});
		},
		selectCity(city) {
			this.selected_city = city;
		},
		save() {
			this.error = '';
			this.submitCity(this.selected_city);
		},
		getCurrentUser() {
			this.key = this.storage.get('session_key');
			if (this.storage.isSet('authed_user')) {
				this.user = this.storage.get('authed_user');
				this.selected_city = this.user.city;
			}
		}
    }
}
</script>